import {rootState} from '@mintdata-wsp/common/state/RootState';
import {PropertiesVisiblePopover} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {MLogo} from '@mintdata-wsp/wsp/ui/components/logo/MLogo';
import {CellSettingsBar} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/cellSettingsBar/CellSettingsBar';
import {TopFormulaEditor} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/topFormulaEditor/TopFormulaEditor';
import {TopBarCollapsedMenuButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/buttons/TopBarCollapsedMenuButton';
import {TopBarExpandedMenuButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/buttons/TopBarExpandedMenuButton';
import {TopBarButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/TopBarButton';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import * as classnames from 'classnames/bind';
import {action, computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SpreadsheetHeader.less');
const cx = classnames.bind(styles);

export interface ISpreadsheetHeaderProps
{

}

@observer
export class SpreadsheetHeader extends React.Component<ISpreadsheetHeaderProps>
{
    // test, TODO: move in rootstate
    // @observable isViewStyleBar:boolean = true;

    private _handleHideBtnClick = (event:React.MouseEvent<HTMLElement>) =>
    {
        const {workbenchVisibility, surfacePropertiesPanel} = controllers.ui;

        surfacePropertiesPanel.setPropertiesPopover(PropertiesVisiblePopover.None);

        if( workbenchVisibility.isSpreadsheetFullScreen() )
            workbenchVisibility.toggleSpreadsheetFullScreen();
        else
            workbenchVisibility.setSpreadsheetVisibility(false);
    };

    @action
    private _handleCellSettingsBarBtnClick = (event:React.MouseEvent<HTMLElement>) =>
    {
        const {cellSettingsBar} = controllers.ui.spreadsheets;

        cellSettingsBar.toggleBarVisibility();

        const {mesh} = controllers.ui.spreadsheets;

        mesh.focusMeshOrControl(this._focusedMeshCtx);
    };

    public render():JSX.Element
    {
        const {workbenchVisibility, topMenu, openDesign} = controllers.ui;
        const {cellSettingsBar} = rootState.ui.visualDesigner.workbench;

        const {sampleDesign} = rootState.ui.visualDesigner;

        const isSampleDesign:boolean = openDesign.isInSampleDesignMode();
        const isViewModeShowOnlyTable:boolean = sampleDesign && !sampleDesign.showSurface;

        const isTopMenuExpanded:boolean = topMenu.isTopMenuExpanded();
        const isCollapsingTransitionInProgress:boolean = topMenu.isCollapsingTransitionInProgress();
        const isSpreadsheetFullScreen:boolean = workbenchVisibility.isSpreadsheetFullScreen();

        return (
            <div className={cx('base', {isTopMenuExpanded})}>

                <div className={cx('row', {isSampleDesign, isViewModeShowOnlyTable, isSpreadsheetFullScreen})}>
                    {
                        !isViewModeShowOnlyTable && isSpreadsheetFullScreen &&
                        <div
                            className={cx(
                                'logoAndCollapsedMenuButton',
                                {
                                    isVisible: !isTopMenuExpanded && !isCollapsingTransitionInProgress,
                                    isSampleDesign
                                }
                            )}
                            onTransitionEnd={() => topMenu.endTopMenuLogoTransition()}
                        >
                            <MLogo tooltipProps={{content: 'Go to Workspace'}} iconClassName={cx('logoIcon')} />
                            {
                                !isSampleDesign &&
                                <div className={cx('collapsedMenuButton')}>
                                    <TopBarCollapsedMenuButton />
                                </div>
                            }
                        </div>
                    }
                    {
                        !isViewModeShowOnlyTable &&
                        <TopBarButton
                            className={cx('hideButton')}
                            iconProps={{name: WSPIcons.visualDesigner.spreadsheet.Hide}}
                            onClick={this._handleHideBtnClick}
                        />
                    }
                    <TopFormulaEditor />
                    <TopBarButton
                        className={cx('cellSettingsBarButton')}
                        iconProps={{name: WSPIcons.visualDesigner.cellSettings.Palette}}
                        onClick={this._handleCellSettingsBarBtnClick}
                        tooltipProps={{content: 'StyleBar'}}
                        isToggledOn={cellSettingsBar.isBarVisible}
                    />
                    {
                        !isSampleDesign &&
                        <div className={cx('expandedMenuBarButton')}>
                            <TopBarExpandedMenuButton />
                        </div>
                    }
                    <div className={cx('lxPlaceholder', {isTopMenuExpanded})}></div>
                </div>

                {cellSettingsBar.isBarVisible && (
                    <div className={cx('row', 'cellSettingsBar')}>
                        <CellSettingsBar />
                    </div>
                )}

            </div>
        );
    }

    @computed
    private get _focusedSheetId():SheetId
    {
        const {main} = controllers.ui.spreadsheets;

        const workbook = main.getRootWorkbook();
        if( !workbook ) return;

        return workbook.view.focusedSheetId;
    }

    @computed
    private get _focusedMeshCtx():IWSPMeshContext
    {
        return controllers.ui.spreadsheets.workbook.getMeshContextBySheetId(this._focusedSheetId);
    }
}
